import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';

const IndustryApplicationsSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  // Define industries using translation keys
  const createIndustry = (key) => {
    let icon;
    let image;
    
    switch (key) {
      case 'oil':
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
        );
        image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Cpath d='M50,150 L250,150 M50,150 L50,50 M100,150 L100,75 M150,150 L150,100 M200,150 L200,75 M250,150 L250,50' stroke='%23d1d5db' stroke-width='10' fill='none'/%3E%3Ccircle cx='50' cy='50' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='100' cy='75' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='150' cy='100' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='200' cy='75' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='250' cy='50' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3C/svg%3E")`;        
        break;
      case 'chemical':
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
          </svg>
        );
        image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Ccircle cx='75' cy='100' r='50' fill='%23d1d5db'/%3E%3Ccircle cx='225' cy='100' r='50' fill='%23d1d5db'/%3E%3Crect x='75' y='75' width='150' height='50' fill='%23d1d5db'/%3E%3Ccircle cx='75' cy='100' r='25' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='225' cy='100' r='25' fill='%23FF6B00' fill-opacity='0.3'/%3E%3C/svg%3E")`;
        break;
      case 'power':
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        );
        image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Cpath d='M150,50 L75,150 L225,150 Z' fill='%23d1d5db'/%3E%3Cpath d='M150,75 L100,150 L200,150 Z' fill='%23e5e7eb'/%3E%3Ccircle cx='150' cy='100' r='25' fill='%23FF6B00' fill-opacity='0.3'/%3E%3C/svg%3E")`;   
        break;
      case 'manufacturing':
        icon = (
          <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '48px', height: '48px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        );
        image = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%23f3f4f6'/%3E%3Crect x='50' y='75' width='50' height='75' fill='%23d1d5db'/%3E%3Crect x='125' y='50' width='50' height='100' fill='%23d1d5db'/%3E%3Crect x='200' y='100' width='50' height='50' fill='%23d1d5db'/%3E%3Ccircle cx='75' cy='75' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='150' cy='50' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3Ccircle cx='225' cy='100' r='15' fill='%23FF6B00' fill-opacity='0.3'/%3E%3C/svg%3E")`;
        break;
      default:
        icon = null;
        image = '';
    }
    
    return {
      title: t(`projects.industries.${key}`),
      description: t(`projects.industries.descriptions.${key}`),
      icon: icon,
      applications: language === 'fr' 
        ? t(`projects.industries.applications.${key}`, { returnObjects: true })
        : language === 'ar'
        ? t(`projects.industries.applications.${key}`, { returnObjects: true })
        : t(`projects.industries.applications.${key}`, { returnObjects: true }),
      image: image
    };
  };

  const industries = [
    createIndustry('oil'),
    createIndustry('chemical'),
    createIndustry('power'),
    createIndustry('manufacturing')
  ];

  return (
    <section className="section section-dark" style={{ 
      position: 'relative',
      overflow: 'hidden',
      paddingTop: '6rem',
      paddingBottom: '6rem'
    }}>
      {/* Decorative background with updated pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23FF6B00' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        opacity: 0.7
      }}></div>
      
      {/* Decorative circles */}
      <div style={{
        position: 'absolute',
        top: '5%',
        right: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '5%',
        left: '5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <span className="fade-in" style={{
          display: 'block',
          textAlign: 'center',
          padding: '0.5rem 1.5rem',
          backgroundColor: 'rgba(255, 107, 0, 0.1)',
          color: 'var(--assco-orange)',
          fontWeight: '600',
          fontSize: '0.875rem',
          borderRadius: 'var(--radius-full)',
          width: 'fit-content',
          margin: '0 auto 1rem'
        }}>
          {language === 'fr' ? 'SECTEURS D\'ACTIVITÉ' : 
           language === 'ar' ? 'قطاعات النشاط' : 
           'INDUSTRY SECTORS'}
        </span>
        
        <h2 className="text-center fade-in" style={{ 
          fontSize: '2.75rem', 
          marginBottom: '1.5rem',
          position: 'relative',
          paddingBottom: '1.5rem',
          fontWeight: '700'
        }}>
          {t('projects.industries.title')}
          <span style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '4px',
            backgroundColor: 'var(--assco-orange)',
            borderRadius: '2px'
          }}></span>
        </h2>
        
        <p className="subtitle text-center fade-in" style={{ 
          maxWidth: '800px',
          margin: '0 auto 4.5rem',
          fontSize: '1.2rem',
          color: 'rgba(255, 255, 255, 0.85)',
          lineHeight: '1.8'
        }}>
          {t('projects.industries.subtitle')}
        </p>
        
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
          gap: '3rem'
        }}>
          {industries.map((industry, index) => (
            <div 
              key={index}
              className="industry-card fade-in"
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                borderRadius: 'var(--radius-xl)',
                overflow: 'hidden',
                boxShadow: '0 20px 30px rgba(0, 0, 0, 0.07)',
                transition: 'all 0.3s ease',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                animationDelay: `${0.15 * index}s`,
                border: '1px solid var(--assco-gray-100)'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-15px)';
                e.currentTarget.style.boxShadow = '0 30px 40px rgba(0, 0, 0, 0.12)';
                e.currentTarget.style.borderColor = 'var(--assco-orange)';
                
                // Change icon style
                const iconContainer = e.currentTarget.querySelector('.industry-icon');
                if (iconContainer) {
                  iconContainer.style.backgroundColor = 'var(--assco-orange)';
                  iconContainer.style.transform = 'scale(1.1) rotate(0deg)';
                  iconContainer.style.boxShadow = '0 15px 25px rgba(255, 107, 0, 0.25)';
                }
                
                const iconInner = e.currentTarget.querySelector('.industry-icon svg');
                if (iconInner) {
                  iconInner.style.transform = 'scale(1.1)';
                }
                
                // Change background overlay
                const overlay = e.currentTarget.querySelector('.industry-bg-overlay');
                if (overlay) {
                  overlay.style.opacity = '0.7';
                }
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 20px 30px rgba(0, 0, 0, 0.07)';
                e.currentTarget.style.borderColor = 'var(--assco-gray-100)';
                
                // Reset icon style
                const iconContainer = e.currentTarget.querySelector('.industry-icon');
                if (iconContainer) {
                  iconContainer.style.backgroundColor = 'var(--assco-gray-800)';
                  iconContainer.style.transform = 'scale(1) rotate(-5deg)';
                  iconContainer.style.boxShadow = '0 15px 25px rgba(0, 0, 0, 0.1)';
                }
                
                const iconInner = e.currentTarget.querySelector('.industry-icon svg');
                if (iconInner) {
                  iconInner.style.transform = 'scale(1)';
                }
                
                // Reset background overlay
                const overlay = e.currentTarget.querySelector('.industry-bg-overlay');
                if (overlay) {
                  overlay.style.opacity = '0.5';
                }
              }}
            >
              <div style={{ 
                height: '220px',
                backgroundImage: industry.image,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                position: 'relative'
              }}>
                {/* Dark overlay to improve contrast */}
                <div 
                  className="industry-bg-overlay"
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'var(--assco-gray-900)',
                    opacity: 0.5,
                    transition: 'opacity 0.3s ease'
                  }}
                ></div>
                
                {/* Industry title banner at bottom */}
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  backgroundColor: 'rgba(0, 0, 0, 0.75)',
                  backdropFilter: 'blur(5px)',
                  color: 'white',
                  padding: '1.25rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.35rem',
                  fontWeight: '600',
                  textAlign: 'center'
                }}>
                  {industry.title}
                </div>
                
                <div 
                  className="industry-icon"
                  style={{
                    position: 'absolute',
                    top: '20px',
                    right: '20px',
                    width: '70px',
                    height: '70px',
                    borderRadius: '15px',
                    backgroundColor: 'var(--assco-gray-800)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    boxShadow: '0 15px 25px rgba(0, 0, 0, 0.1)',
                    transform: 'rotate(-5deg)',
                    transition: 'all 0.3s ease',
                    zIndex: 5
                  }}
                >
                  <div style={{ transition: 'transform 0.3s ease' }}>
                    {industry.icon}
                  </div>
                </div>
              </div>
              
              <div style={{ padding: '2.25rem', flex: '1', display: 'flex', flexDirection: 'column' }}>
                <p style={{ 
                  fontSize: '1.1rem',
                  lineHeight: '1.8',
                  color: 'rgba(255, 255, 255, 0.85)',
                  marginBottom: '2rem',
                  position: 'relative',
                  paddingBottom: '1.5rem',
                  borderBottom: '1px dashed rgba(0, 0, 0, 0.1)'
                }}>
                  {industry.description}
                </p>
                
                <div style={{ marginBottom: '2rem', flex: '1' }}>
                  <h4 style={{ 
                    fontSize: '1.2rem',
                    marginBottom: '1.25rem',
                    color: 'var(--assco-gray-800)',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                  }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: 'rgba(255, 107, 0, 0.15)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '14px', height: '14px', color: 'var(--assco-orange)' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    {t('projects.industries.key_applications')}
                  </h4>
                  
                  <ul style={{ 
                    listStyleType: 'none',
                    padding: 0,
                    margin: 0
                  }}>
                    {industry.applications.map((application, idx) => (
                      <li 
                        key={idx}
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          marginBottom: '1rem',
                          paddingLeft: language === 'ar' ? 0 : '1.75rem',
                          paddingRight: language === 'ar' ? '1.75rem' : 0,
                          position: 'relative'
                        }}
                      >
                        <div style={{
                          position: 'absolute',
                          left: language === 'ar' ? 'auto' : 0,
                          right: language === 'ar' ? 0 : 'auto',
                          top: '0.4rem',
                          width: '18px',
                          height: '18px',
                          borderRadius: '50%',
                          backgroundColor: 'rgba(255, 107, 0, 0.1)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            backgroundColor: 'var(--assco-orange)'
                          }}></div>
                        </div>
                        <span style={{ 
                          fontSize: '1.05rem',
                          color: 'var(--assco-gray-700)',
                          lineHeight: '1.6'
                        }}>
                          {application}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
                
                <Link 
                  to="/contact" 
                  className="btn-text"
                  style={{
                    color: 'white',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.75rem',
                    fontSize: '1rem',
                    fontWeight: '600',
                    marginTop: 'auto',
                    backgroundColor: 'var(--assco-orange)',
                    border: 'none',
                    padding: '0.85rem 1.75rem',
                    borderRadius: 'var(--radius-xl)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    textDecoration: 'none',
                    boxShadow: '0 10px 15px rgba(255, 107, 0, 0.15)',
                    alignSelf: 'center',
                    width: 'auto'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = 'translateY(-5px)';
                    e.currentTarget.style.boxShadow = '0 15px 20px rgba(255, 107, 0, 0.25)';
                    const svg = e.currentTarget.querySelector('svg');
                    if (svg) {
                      svg.style.transform = 'translateX(3px)';
                    }
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 15px rgba(255, 107, 0, 0.15)';
                    const svg = e.currentTarget.querySelector('svg');
                    if (svg) {
                      svg.style.transform = 'translateX(0)';
                    }
                  }}
                >
                  {t('projects.industries.discuss_project')}
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px', transition: 'transform 0.3s ease' }} viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustryApplicationsSection;
